export default __webpack_public_path__ + "static/media/240-azores-islands.2e2f191a.svg";